import React from "react";
import CustomSelect from "../../../components/ui/CustomSelect";

export default function UploadDocumentModal({
 isOpen,
 onClose,
 onAdd,
 documentData,
 setDocumentData
}) {
 if (!isOpen) return null;

 return (
 <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-md z-50">
 <div className="bg-surface p-6 rounded-lg shadow-xl w-96">
 <h2 className="text-xl font-semibold text-primary mb-4">Ajouter un document</h2>

 {/* Importer un fichier */}
 <label className="block text-sm font-medium text-muted">Importer un fichier</label>
 <input
 type="file"
 accept=".pdf,image/*"
 onChange={(e) => {
 const file = e.target.files[0];
 if (file) {
 setDocumentData({
 ...documentData,
 nom: file.name,
 fichier: file
 });
 }
 }}
 className="w-full p-2 border rounded-lg mb-3"
 />

 {/* Nom auto-rempli, modifiable */}
 <label className="block text-sm font-medium text-muted">Nom</label>
 <input
 type="text"
 value={documentData.nom}
 onChange={(e) =>
 setDocumentData({ ...documentData, nom: e.target.value })
 }
 className="w-full p-2 border rounded-lg mb-3"
 />

 {/* Type du document */}
 <label className="block text-sm font-medium text-muted mb-1">Type</label>
 <div className="mb-4">
   <CustomSelect
     value={documentData.type}
     onChange={(val) => setDocumentData({ ...documentData, type: val })}
     options={[
       { value: "pdf", label: "PDF" },
       { value: "image", label: "Image" }
     ]}
   />
 </div>

 {/* Boutons d'action */}
 <div className="flex justify-end space-x-3">
 <button
 onClick={onClose}
 className="px-4 py-2 bg-surface-muted hover:bg-ink-300 rounded-lg"
 >
 Annuler
 </button>
 <button
 onClick={onAdd}
 className="px-4 py-2 bg-primary hover:bg-primary text-white rounded-lg"
 >
 Ajouter
 </button>
 </div>
 </div>
 </div>
 );
}
